import { $createLineBreakNode, $createParagraphNode, $createTextNode, $getRoot, createEditor, } from 'lexical';
/**
 * Creates a Composer-compatible serialized draft from plain text.
 *
 * Use this only at boundaries where the source data is inherently string-only.
 * Rich drafts should stay as `SerializedEditorState` so mentions, links, and
 * other registered nodes survive whole-draft replacement.
 */
export function createPlainTextComposerValue(plainText) {
    const editor = createEditor({ onError: () => { } });
    editor.update(() => {
        const paragraph = $createParagraphNode();
        plainText.split('\n').forEach((line, index) => {
            if (index > 0)
                paragraph.append($createLineBreakNode());
            if (line !== '')
                paragraph.append($createTextNode(line));
        });
        $getRoot().append(paragraph);
    }, { discrete: true });
    return editor.getEditorState().toJSON();
}
//# sourceMappingURL=createPlainTextComposerValue.js.map